import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QMultiSelect, QSelectPlaceholder, QText } from '@qualio/ui-components';
import { ProbabilityType } from '../../../types/eventMetadata';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';
import { emptyAwareFilterOption } from './emptyAwareFilterOption';

export const ProbabilityFilter = ({
  isLoadingProbabilities,
  probabilities,
}: {
  isLoadingProbabilities: boolean;
  probabilities: ProbabilityType[];
}) => {
  const { t } = useTranslation();
  const options: Array<{ value: string; label: React.ReactNode }> = [
    { value: EMPTY_FILTER_VALUE, label: <em>{t('common.labels.emptyProbabilities')}</em> },
    ...probabilities.map((probability) => ({
      value: probability.id,
      label: probability.name,
    })),
  ];

  return (
    <QFormControl label={t('common.labels.probability')} data-cy="probability-filter" w="300px">
      <Controller
        name={'probability_ids'}
        render={({ field: { onChange, value } }) => (
          <QMultiSelect
            options={options}
            aria-label="probability-filter"
            onChange={(val) => onChange(val.map((c) => c.value))}
            value={value ?? []}
            isLoading={isLoadingProbabilities}
            filterOption={emptyAwareFilterOption}
          >
            <QSelectPlaceholder>
              <QText>{t('common.filters.filterByProbability')}</QText>
            </QSelectPlaceholder>
          </QMultiSelect>
        )}
      />
    </QFormControl>
  );
};

export default ProbabilityFilter;
